export const notificationTypes = {
	STOCKALERT: "stockalert",
	MARKEDASREAD: "markedAsRead",
};
